module.exports = __webpack_public_path__ + "img/60.a9e2fc7e.png";